class ToTopButtonModule {
  constructor() {
    this.toTopButton = document.querySelector('.m-toTopButton');
    if (!this.toTopButton) return;

    this.bottomNavi = document.querySelector('.m-bottomNavi');
    this.topHideY = 200;

    this.init();
  }

  updateOffset() {
    let offset = 16;
    if (this.bottomNavi && this.bottomNavi.classList.contains('is-bottom-visible')) {
      offset += this.bottomNavi.getBoundingClientRect().height + 12;
    }
    document.documentElement.style.setProperty('--to-top-bottom', `${offset}px`);
  }

  updateVisibility() {
    this.toTopButton.classList.toggle('is-visible', window.scrollY > this.topHideY);
  }

  update() {
    this.updateVisibility();
    this.updateOffset();
  }

  init() {
    this.toTopButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    this.update();
    window.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
  }
}

export default ToTopButtonModule;
